import { useLocation } from 'react-router-dom'
import queryString from 'query-string'
import { DashboardQuery } from '../types'

export function useGetURLParams(): DashboardQuery {
  const location = useLocation()
  return queryString.parse(location.search)
}
